import React from 'react';
import './Projects.css';
// eslint-disable-next-line
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import {Row, Col , Container} from 'react-bootstrap';
import ProjectCard from '../ProjectCard/ProjectCard';
import imageRest1 from '../../images/1rest.JPG';
import imageRest2 from '../../images/2rest.JPG';
import imageRest3 from '../../images/3rest.JPG';
import imageRest4 from '../../images/4rest.JPG';
import imageHotel1 from '../../images/hotel1.JPG';
import imageHotel2 from '../../images/hotel2.JPG';
import imageHotel3 from '../../images/hotel3.JPG';
import imageAlm7aseb1 from '../../images/alm7aseb1.JPG';
import imageAlm7aseb2 from '../../images/alm7aseb2.JPG';
import imageAlm7aseb3 from '../../images/alm7aseb3.JPG';


const Projects = () => {
    const { t, i18n } = useTranslation();

    return (
    <section id="ourprojects" className="ourprojects">
        <div className="container" data-aos="fade-up" data-aos-duration="900" >
            <div className="section-title">
            <h2>{t('OurProjects')}</h2>
            <p>{t('These_are_our_best_programs')}</p>
            </div>
        </div>
        <Container>
            <Row xs={1} md={3} className="g-4">
                    <Col >
                        <ProjectCard Title={t('Restaurant_Program')} Text={t('Management_program_for_restaurants')} image1={imageRest1}  image2={imageRest2} image3={imageRest3} image4={imageRest4} interval="5000" tolink="/Resturant"/>
                    </Col>
                    <Col >
                        <ProjectCard Title={t('Hotel_Program')} Text={t('Hotel_management_program')} image1={imageHotel1} image2={imageHotel2} image3={imageHotel3} image4={imageHotel2}interval="6000" tolink="/Alm7seb" />
                    </Col>
                    <Col >
                        <ProjectCard Title={t('Alm7seb')} Text={t('Professional_financial')} image1={imageAlm7aseb1} image2={imageAlm7aseb2} image3={imageAlm7aseb3} image4={imageAlm7aseb2} interval="5500" tolink="/Alm7seb" />
                    </Col>
            </Row>
            </Container>

    </section>
    )
}

export default Projects
